module.exports = __webpack_public_path__ + "img/australia-liver-cancer-male.ebd57537.png";